import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDeptTree } from '@/api/system/dept/dept';
import { fetchRoleDeptUser, fetchCreateRoleUser } from '@/api/system/role/role';
export default {
  data: function data() {
    return {
      deptData: [],
      addIdList: [],
      checkItems: [],
      userIds: [],
      defaultProps: {
        label: 'deptName',
        children: 'childDept'
      }
    };
  },
  props: ['roleId', 'showDialog'],
  created: function created() {
    this.loadDeptTree();
    this.loadMenber();
  },
  watch: {
    showDialog: function showDialog(n, o) {
      this.addIdList = [];
      this.deptData = [];
      this.userIds = [];

      if (n) {
        if (this.showDialog) {
          this.loadDeptTree();
          this.loadMenber();
        }
      }
    }
  },
  methods: {
    loadDeptTree: function loadDeptTree() {
      var _this = this;

      var treeQuery = {};
      fetchDeptTree(treeQuery).then(function (response) {
        _this.deptData = response.data.data;
      });
    },
    loadMenber: function loadMenber() {
      var _this2 = this;

      fetchRoleDeptUser(this.roleId, 0).then(function (response) {
        response.data.data.forEach(function (e) {
          if (e.isCheck > 0) {
            _this2.addIdList.push(e.userId);
          }

          _this2.userIds.push(e);
        });
      });
    },
    handleNodeClick: function handleNodeClick(data) {
      var _this3 = this;

      this.userIds = [];
      fetchRoleDeptUser(this.roleId, data.deptId).then(function (response) {
        response.data.data.forEach(function (e) {
          _this3.userIds.push(e);
        });
      });
    },
    handCreate: function handCreate() {
      var _this4 = this;

      fetchCreateRoleUser(this.roleId, this.addIdList).then(function (response) {
        _this4.$emit('handCancle', true);

        _this4.Alert({
          alertType: 'add',
          message: '角色配置人员成功'
        });
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};